import { Card } from "antd";
import classNames from "classnames";

import "./ChartCard.style.less";

const ChartCard = ({ children, ...cardProps }) => (
  <Card
    size="small"
    {...cardProps}
    classNames={{
      root: classNames("chart-card", cardProps?.className),
      extra: "chart-card--extra",
    }}
  >
    {children}
  </Card>
);

export default ChartCard;
